import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.RowStrip = class RowStrip extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-row-strip';
	}

	constructor(element) {
		super(element);

		this.backgroundImage = new Image();
	}

	render() {
		this.setVars();
		this.setStripDisplayRules();
		this.setEventListeners();
	}

	setVars() {
		this.options = {
			images: {
				small: this.$element.data('smallImage'),
				large: this.$element.data('largeImage')
			},
			backgroundColor: this.$element.data('backgroundColor')
		};
	}

	setEventListeners() {
		window.addEventListener('fa.viewportResize', this.setRelevantBackground.bind(this));
	}

	setStripDisplayRules() {
		if (this.options.images.small && this.options.images.large) {
			this.setRelevantBackground();
		} else {
			this.setStripColor();
		}
	}

	setRelevantBackground() {

		/**
		* This functionality has a bug which results in the '--loaded' class not being added to elements with class '.fa-row-strip'.
		* This bug causes many components tobe left hidden on mobile
		*
		* The CSS transition for the 'fa-row-strip' class has been temporarily disabled until a fix can be found
		*/

		this.imageToRequest = window.globalConfigs.viewportIsBelowLarge ? this.options.images.small : this.options.images.large;

		if (this.imageToRequest !== this.cachedImagePath) {
			this.backgroundImage.src = this.imageToRequest;
			this.backgroundImage.onload = this.onImageLoadedSuccess.bind(this);
			this.backgroundImage.onerror = this.fallbackToDefault.bind(this);

			this.cachedImagePath = this.imageToRequest;
		}
	}

	onImageLoadedSuccess() {
		this.$element.css({
			backgroundImage: `url(${this.imageToRequest})`
		});

		this.setStripReady();
	}

	fallbackToDefault() {
		this.setStripReady();
	}

	setStripReady() {
		this.$element.addClass('fa-row-strip--loaded');
	}

	setStripColor() {
		const backgroundColor = this.options.backgroundColor;

		if (backgroundColor) {
			this.$element.css({
				backgroundColor: backgroundColor
			});
		}

		this.setStripReady();
	}
};



// WEBPACK FOOTER //
// ./components/rowStrip/scripts/rowStrip.js